import BaseService from './BaseService'
import axios from "axios/index";
import entities from 'src/config/entities'

class ProductsService extends BaseService {

  constructor() {
    super({entity: entities.PRODUCT});
  }

   async getJobBoards(params,path) {
     try {
       return await super.get(params, path);
     } catch (e) {
       this._handleError({translationKey: 'generic.get.error', error: e});
       throw e;
     }
  }

  async filterProducts({ client_id }) {
    let data = {
      "filters": [
        {
          "field": "client_uuid",
          "operator": "IS",
          "value": client_id
        }
      ],
      "sort": {
        "page": 1,
        "limit": 20
      },
      "withs": [
        'product_job_board'
      ]
    }
    return this.instance.post(`/pricing/filter`, data)
  }

  async createProductPricing(data) {
    try {
      let res = await this.instance.post(`/pricing`, data)
      this._handleSuccess({ translationKey: 'generic.create.success', data});
      return res
    } catch (e) {
      this._handleError({translationKey: 'generic.create.error', error: e});
      throw e;
    }
  }

  async deleteProductPricing(id) {
    try {
      let res = await this.instance.delete(`/pricing/${id}`)
      this._handleSuccess({ translationKey: 'generic.delete.success'});
      return res
    } catch (e) {
      this._handleError({translationKey: 'generic.delete.error', error: e});
      throw e;
    }
  }

  async createProductOnJobBoard(productId, data) {
    try {
      let res = await axios.post(`/products/${productId}/job-boards`, data)
      this._handleSuccess({ translationKey: 'generic.create.success', data});
      return res;
    } catch (e) {
      this._handleError({translationKey: 'generic.create.error', error: e});
      throw e;
    }
  }
  async updateProductOnJobBoard(productJobBoardId, productId, data) {
    try {
      let res = await axios.put(`/products/${productId}/job-boards/${productJobBoardId}`, data)
      this._handleSuccess({ translationKey: 'generic.update.success', data});
      return res;
    } catch (e) {
      this._handleError({translationKey: 'generic.update.error', error: e});
      throw e;
    }
  }

  async deleteProductFromJobBoard(productId, jobBoardId) {
    try {
      let res = await axios.delete(`/products/${productId}/job-boards/${jobBoardId}`)
      this._handleSuccess({ translationKey: 'generic.delete.success', id: productId});
      return res;
    } catch (e) {
      this._handleError({translationKey: 'generic.delete.error', error: e});
      throw e;
    }
  }

  async createProductRule(productId, data) {
    try {
      let res = await axios.post(`/products/${productId}/rules`, data)
      this._handleSuccess({ translationKey: 'generic.create.success', data});
      return res;
    } catch (e) {
      this._handleError({translationKey: 'generic.create.error', error: e});
      throw e;
    }
  }

  async updateProductRule(productId, data) {
    try {
      let res = await axios.put(`/products/${productId}/rules/${data.id}`, data)
      this._handleSuccess({ translationKey: 'generic.update.success', data});
      return res;
    } catch (e) {
      this._handleError({translationKey: 'generic.update.error', error: e});
      throw e;
    }
  }

  async getProductRule(productId, ruleId) {
    try {
      let res = await axios.get(`/products/${productId}/rules/${ruleId}`)
      return res;
    } catch (e) {
      this._handleError({translationKey: 'generic.get.error', error: e});
      throw e;
    }
  }

  async getRules(productId, params) {
    return axios.get(`/products/${productId}/rules`, params);
  }
}

export default new ProductsService();
